import classnames from 'classnames';
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GTMTracking } from '@common/ui/general';

import {
  paginationSelector,
  requestParamsSelector,
  testimonialsSelector,
  loadingSelector,
} from '@alumni_v2/selectors/reviews';
import { updateRequestParams } from '@alumni_v2/stores/reviews/actions';

import styles from './FilterTagsNew.module.scss';

const FilterTagsNew = ({ clearAllFilters, trackNoAlumniFound }) => {
  const dispatch = useDispatch();
  const requestParams = useSelector(requestParamsSelector) || {};
  const pagination = useSelector(paginationSelector);
  const testimonials = useSelector(testimonialsSelector) || [];
  const loading = useSelector(loadingSelector);

  const [showNoAlumniFound, setShowNoAlumniFound] = useState(false);
  const noResultFilters = useRef(new Set());

  const handleClearAllFilters = useCallback(() => {
    clearAllFilters();
    setShowNoAlumniFound(false);
  }, [clearAllFilters]);

  const ContentUI = ({ alumniCount }) => (
    <div className={classnames(
      styles.container,
      { [styles.addGapBetween]: !showNoAlumniFound },
    )}
    >
      <div className={styles.title}>
        Filtered Results
        {' '}
        <span>
          (
          {alumniCount}
          )
        </span>
      </div>
      <GTMTracking
        className={styles.clearAllButton}
        onClick={handleClearAllFilters}
        component="button"
        gtmEventType="cta"
        gtmEventAction="click"
        gtmEventResult="clear_all_filter"
        gtmEventCategory="alumni_directory"
        gtmEventData={{
          click_type: 'clear_all_filter',
          click_text: 'Clear All Filters',
          click_section: 'quick_filter_section',
        }}
      >
        Clear All Filters
      </GTMTracking>
    </div>
  );

  useEffect(() => {
    const filterKey = JSON.stringify({
      search: requestParams.search,
      quickFilters: requestParams.quickFilters,
      advancedFilters: requestParams.advancedFilters,
    });

    if (
      (requestParams.search
        || requestParams.quickFilters?.length
        || Object.keys(requestParams.advancedFilters || {}).length > 0)
        && !loading
    ) {
      if (testimonials.length === 0) {
        if (!noResultFilters.current.has(filterKey)) {
          noResultFilters.current.add(filterKey);
        }
        trackNoAlumniFound();
        dispatch(updateRequestParams(
          [], {}, null, false, true,
        ));
      }
      if (noResultFilters.current.has(filterKey)) {
        setShowNoAlumniFound(true);
      } else {
        setShowNoAlumniFound(false);
      }
    }
  }, [requestParams, testimonials, trackNoAlumniFound, loading, dispatch]);


  if (showNoAlumniFound) {
    return (
      <div className={styles.noAlumniFoundWrapper}>
        <ContentUI alumniCount="No exact match found" />
        <div className={styles.noAlumniFoundText}>
          Showing other similar results
        </div>
      </div>
    );
  } else if (
    (requestParams.search
      || requestParams.quickFilters?.length
      || Object.keys(requestParams.advancedFilters || {}).length)
      && testimonials.length > 0
  ) {
    return <ContentUI alumniCount={pagination?.totalEntries} />;
  } else return null;
};

export default FilterTagsNew;
